import { render, staticRenderFns } from "./OrderTypeStep.vue?vue&type=template&id=704e4408&scoped=true"
import script from "./OrderTypeStep.vue?vue&type=script&lang=js"
export * from "./OrderTypeStep.vue?vue&type=script&lang=js"
import style0 from "./OrderTypeStep.vue?vue&type=style&index=0&id=704e4408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704e4408",
  null
  
)

export default component.exports